import { register } from 'register-service-worker'

import { setContext } from '@/services/sentry'

import { BUILD_ENVIRONMENT } from './services/config'

if (BUILD_ENVIRONMENT === 'production') {
  const { origin } = window.location

  register(origin + '/service-worker.js', {
    registrationOptions: { scope: './' },
    ready() {
      console.info(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB',
      )
    },
    registered() {
      console.info('Service worker has been registered.')
    },
    cached() {
      console.info('Content has been cached for offline use.')
    },
    updatefound() {
      console.info('New content is downloading.')
    },
    updated() {
      console.info('New content is available; please refresh.')
    },
    offline() {
      console.info('No internet connection found. App is running in offline mode.')
    },
    error(error: unknown) {
      setContext('context', { error: error })
      console.error('Error during service worker registration')
    },
  })
}
